export default (function (arr) { return arr.slice(0, -1); });
